import { generateRandomPassword } from "../../Utils/utilities";
import { useContext } from "react";
import { useFormik } from "formik";
import addAccountSchema from "../Schemas/addAccountSchema";
import BaseButton from "../Buttons/BaseButton";
import BaseForm from "../Form/BaseForm";
import BaseModal from "./BaseModal";
import ButtonGroup from "../Buttons/ButtonGroup";
import ErrorButton from "../Buttons/ErrorButton";
import FieldAccountType from "../Form/Fields/FieldAccountType";
import FieldDomain from "../Form/Fields/FieldDomain";
import FieldInput from "../Form/Fields/FieldInput";
import FieldPassword from "../Form/Fields/FieldPassword";
import MediaQueryContextProvider from "../../Context/MediaQueryContext";
import SubmitButton from "../Buttons/SubmitButton";
import translate from "../../Utils/translate";

const AddAccountModal = ({ defaultValues, handleCloseModal, handleSubmit }) => {
  const formik = useFormik({
    initialValues: {
      domain: defaultValues?.domain ?? "",
      icon: defaultValues?.icon ?? "",
      appName: defaultValues?.appName ?? "",
      accountName: defaultValues?.accountName ?? "",
      email: defaultValues?.email ?? "",
      username: defaultValues?.username ?? "",
      password: defaultValues?.password ?? "",
      tags: defaultValues?.tags[0] ?? "",
    },
    validateOnChange: false,
    validationSchema: addAccountSchema,
    onSubmit: async (values, { resetForm }) => {
      await handleSubmit(values);
      resetForm();
    },
  });

  const { isDesktop } = useContext(MediaQueryContextProvider);

  const generatePassword = (event) => {
    formik.setFieldValue("password", generateRandomPassword());
  };

  const title =
    defaultValues && Object.entries(defaultValues).length
      ? translate("pages.account_modal.header.edit")
      : translate("pages.account_modal.header.add");

  const buttonText =
    defaultValues && Object.entries(defaultValues).length
      ? translate("forms.buttons.save_changes")
      : translate("forms.buttons.add_account");

  function getForm() {
    return (
      <BaseForm className="flex flex-col h-full" onSubmit={formik.handleSubmit}>
        <div className="flex-grow [&>*]:mb-default last:mb-0">
          <h1 className="font-bold text-lg">{title}</h1>
          <FieldDomain formik={formik} />
          <FieldInput
            errors={formik.errors}
            name="accountName"
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            placeholder={translate("forms.account_name.placeholder")}
            touched={formik.touched}
            value={formik.values?.accountName}
          />
          <FieldInput
            autoComplete="username"
            errors={formik.errors}
            name="username"
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            placeholder={translate("forms.username_email.placeholder")}
            required={true}
            touched={formik.touched}
            value={formik.values?.username}
          />
          <FieldPassword
            autoComplete="new-password"
            errors={formik.errors}
            name="password"
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            required={true}
            touched={formik.touched}
            value={formik.values?.password}
          />
          <BaseButton onClick={generatePassword} type={"button"} text={translate("forms.buttons.generate_password")} />
          <FieldAccountType formik={formik} required={true} />
        </div>
        <ButtonGroup>
          <ErrorButton text={translate("forms.buttons.cancel")} type="button" onClick={handleCloseModal} />
          <SubmitButton disabled={formik.isSubmitting} text={buttonText} type="submit" />
        </ButtonGroup>
      </BaseForm>
    );
  }

  return isDesktop ? getForm() : <BaseModal handleCloseModal={handleCloseModal}>{getForm()}</BaseModal>;
};

export default AddAccountModal;
